import { useEffect } from "react";
import { Container, Typography, Stack } from "@mui/material";

export default function Payments() {
    useEffect(() => {
        document.title = "Payments | BNB Cleaning";
    }, []);

    return (
        <Container component="section" maxWidth="md">
            <Stack spacing={3} sx={{ minHeight: "80vh", textAlign: "center", justifyContent: "center" }}>
                <Typography variant="h3" fontWeight="bold">
                    Payments
                </Typography>
            </Stack>
        </Container>
    );
}
